import styled from 'styled-components';

const orderCard = styled.div`
  .text-detail-info {
    input {
      height: 23px;
      font-size: 16px;
      font-weight: 400;
      color: #000000;
      line-height: 24px;
    }
    .MuiInputBase-root-MuiInput-root::after {
      border: none;
    }
    .MuiInputBase-root-MuiInput-root:hover:not(.Mui-disabled):before {
      border: none;
    }
  }
  .text-detail-label {
    height: 18px;
    font-size: 14px;
    font-weight: 400;
    color: #a8a8a8;
    line-height: 21px;
  }
  .detail-title {
    margin-bottom: 24px;
    height: 28px;
    font-size: 18px;
    font-weight: 500;
    color: #212121;
    line-height: 27px;
  }
`;
export default orderCard;
